// Ouverture : une seule fois par session, jamais bloquante. Le logo monte, le
// Lumina Pro se lève, sa LED s'allume, la lumière ouvre la page et le logo va
// se poser à sa place dans l'en-tête.
const D = document, H = D.documentElement, W = window;
const racine = D.getElementById('sol-cine');
const passer = D.querySelector('.sol-cn-passer');
const T_ = { logoHaut: 1.0, leve: 1.4, led: 2.35, mot: 2.95, motFin: 4.3, eclat: 4.4, fin: 5.0 };
let etat = 'attente', ctl = null, t = 0;
const debut = performance.now();
W.solCine = { aller: (x) => { W.solCine.pause = true; t = x; indices(x); ctl && ctl.dessiner(x); }, passer: () => finir(true) };

if (racine && H.classList.contains('sol-cn')) {
  W.solCineParti = true;
  passer && passer.addEventListener('click', () => finir(true));
  addEventListener('keydown', clavier);
  addEventListener('wheel', geste, { passive: true });
  addEventListener('touchmove', geste, { passive: true });
  lancer();
} else etat = 'fini';

function clavier(e) { if (['Escape', 'ArrowDown', 'PageDown', 'End'].includes(e.key)) finir(true); }
function geste() { if (performance.now() - debut > 500) finir(true); }

async function lancer() {
  let three = null, modele = null;
  try {
    [three, modele] = await Promise.race([
      Promise.all([import(racine.dataset.three), import(racine.dataset.modele)]),
      new Promise((_, non) => setTimeout(() => non(new Error('lent')), 3400)),
    ]);
    ctl = monter(three, modele);
  } catch (e) { ctl = null; }
  if (etat !== 'attente') { ctl && ctl.liberer(); return; }
  if (!ctl) {
    etat = 'joue';
    racine.classList.add('is-haut');
    setTimeout(() => finir(false), 1400);
    return;
  }
  etat = 'joue';
  racine.classList.add('is-gl');
  requestAnimationFrame(boucle);
  setTimeout(() => { if (etat === 'joue' && !W.solCine.pause && !D.hidden) finir(false); }, 12000);
}

let dernier = 0, images = 0, cumul = 0;
function boucle(now) {
  if (etat === 'fini') return;
  requestAnimationFrame(boucle);
  const dt = dernier ? Math.min(0.05, (now - dernier) / 1000) : 1 / 60;
  dernier = now;
  if (D.hidden || W.solCine.pause) return;
  t += dt;
  images++;
  // Un téléphone qui peine ne subit pas l'intro : on l'écourte.
  if (images > 15 && images <= 75) {
    cumul += dt;
    if (images === 75) {
      const moy = cumul / 60;
      if (moy > 0.034) ctl.alleger();
      if (moy > 0.055 && etat === 'joue') finir(false);
    }
  }
  indices(t);
  ctl.dessiner(t);
  if (t >= T_.fin && etat === 'joue') finir(false);
}

function indices(x) {
  racine.classList.toggle('is-haut', x >= T_.logoHaut);
  racine.classList.toggle('is-mot', x >= T_.mot && x < T_.motFin);
  const e = x >= T_.eclat;
  if (e && ctl) {
    const p = ctl.posTete();
    racine.style.setProperty('--ex', (p.x * 100).toFixed(1) + '%');
    racine.style.setProperty('--ey', (p.y * 100).toFixed(1) + '%');
  }
  racine.classList.toggle('is-eclat', e);
  racine.classList.toggle('is-led', x >= T_.led);
  if (ctl && x >= T_.led) {
    const p = ctl.posTete();
    racine.style.setProperty('--hx', (p.x * 100).toFixed(1) + '%');
    racine.style.setProperty('--hy', (p.y * 100).toFixed(1) + '%');
  }
}

function finir(vite) {
  if (etat === 'sortie' || etat === 'fini') return;
  etat = 'sortie';
  const duree = vite ? 0.5 : 0.95;
  racine.style.setProperty('--sortie', duree + 's');
  poserLogo(duree);
  racine.classList.remove('is-mot');
  racine.classList.add('is-sortie');
  passer && passer.classList.add('is-parti');
  H.classList.remove('sol-cn-verrou');
  H.classList.add('sol-cn-ouvert');
  setTimeout(nettoyer, duree * 1000 + 160);
}

// Le logo de l'intro rejoint exactement celui de l'en-tête.
function poserLogo(duree) {
  const logo = racine.querySelector('.sol-cn-logo');
  const cible = D.querySelector('.header__heading-logo') || D.querySelector('.header__heading-link');
  if (!logo) return;
  // L'animation d'arrivée garde la main sur l'opacité tant qu'on ne la retire pas.
  logo.style.animation = 'none';
  logo.style.transition = 'none';
  const b = cible && cible.getBoundingClientRect();
  if (!b || !b.width || b.bottom < 0) {
    logo.style.transition = `opacity ${duree}s ease`;
    logo.style.opacity = '0';
    return;
  }
  const a = logo.getBoundingClientRect();
  // Le logo de l'intro est empilé, celui de l'en-tête est horizontal : l'emblème
  // se pose sur l'emblème, à la hauteur de l'en-tête, puis s'efface.
  const s = b.height / a.height;
  const tx = b.left + b.height / 2 - (a.left + a.width / 2);
  const ty = b.top + b.height * 0.6 - (a.top + a.height / 2);
  const courant = getComputedStyle(logo).transform;
  logo.style.transform = `translate(${tx}px, ${ty}px) ${courant === 'none' ? '' : courant} scale(${s})`;
  const fin = logo.style.transform;
  logo.style.transform = courant === 'none' ? '' : courant;
  logo.offsetWidth;
  logo.style.transition = `transform ${duree}s cubic-bezier(.65,0,.2,1), opacity ${duree * 0.35}s ease ${duree * 0.65}s`;
  logo.style.opacity = '0';
  logo.style.transform = fin;
}

function nettoyer() {
  etat = 'fini';
  removeEventListener('keydown', clavier);
  removeEventListener('wheel', geste);
  removeEventListener('touchmove', geste);
  try { sessionStorage.setItem('solIntro', '1'); } catch (e) {}
  ctl && ctl.liberer();
  racine.remove();
  passer && passer.remove();
  H.classList.remove('sol-cn', 'sol-cn-ouvert');
}

const doux = (x) => x * x * (3 - 2 * x);
const borne = (a, b, x) => Math.min(1, Math.max(0, (x - a) / (b - a)));
function retour(x) { const c = 1.25; return 1 + (c + 1) * Math.pow(x - 1, 3) + c * Math.pow(x - 1, 2); }

function monter(T, M) {
  const toile = racine.querySelector('canvas');
  const mobile = Math.min(innerWidth, innerHeight) < 700 || matchMedia('(pointer: coarse)').matches;
  const rendu = new T.WebGLRenderer({ canvas: toile, alpha: true, antialias: !mobile });
  rendu.outputColorSpace = T.SRGBColorSpace;
  rendu.toneMapping = T.LinearToneMapping;
  rendu.toneMappingExposure = 1;
  rendu.setPixelRatio(Math.min(devicePixelRatio || 1, mobile ? 1.5 : 2));

  const scene = new T.Scene();
  const cam = new T.PerspectiveCamera(30, 1, 0.1, 100);
  M.eclairer(T, rendu, scene);

  const lumina = M.construireLumina(T);
  const pivot = new T.Group();
  pivot.add(lumina.groupe);
  scene.add(pivot);

  // Poussières de lumière qui montent, comme dans un rayon de matin.
  const n = mobile ? 34 : 70;
  const pos = new Float32Array(n * 3), vit = [];
  for (let i = 0; i < n; i++) {
    pos[i * 3] = (Math.random() - 0.5) * 11;
    pos[i * 3 + 1] = (Math.random() - 0.5) * 8;
    pos[i * 3 + 2] = (Math.random() - 0.5) * 6 - 1;
    vit.push(0.08 + Math.random() * 0.22);
  }
  const geo = new T.BufferGeometry();
  geo.setAttribute('position', new T.BufferAttribute(pos, 3));
  const tache = document.createElement('canvas');
  tache.width = tache.height = 64;
  const c = tache.getContext('2d');
  const d = c.createRadialGradient(32, 32, 0, 32, 32, 32);
  d.addColorStop(0, 'rgba(255,255,255,1)');
  d.addColorStop(0.45, 'rgba(255,236,232,.65)');
  d.addColorStop(1, 'rgba(255,220,226,0)');
  c.fillStyle = d;
  c.fillRect(0, 0, 64, 64);
  const texture = new T.CanvasTexture(tache);
  const poussiere = new T.Points(geo, new T.PointsMaterial({ size: 0.16, map: texture, transparent: true, depthWrite: false, opacity: 0.9 }));
  scene.add(poussiere);

  function cadrer() {
    const l = innerWidth, h = innerHeight;
    rendu.setSize(l, h, false);
    cam.aspect = l / h;
    cam.position.set(0, 0, l / h < 0.62 ? 14.4 : 13);
    cam.updateProjectionMatrix();
  }
  cadrer();
  addEventListener('resize', cadrer);

  let precedent = 0;
  const v = new T.Vector3();
  return {
    dessiner(x) {
      const leve = doux(borne(T_.leve, T_.led + 0.25, x));
      const e = retour(borne(T_.leve, T_.led + 0.25, x));
      pivot.position.y = -7 + (7 + 0.06) * e + Math.sin(x * 1.3) * 0.035 * leve;
      pivot.rotation.y = -1.25 + (1.25 - 0.26) * leve + Math.sin(x * 0.7) * 0.05;
      pivot.rotation.z = -0.16 * leve;
      pivot.rotation.x = 0.1;
      const s = 1 + 0.09 * doux(borne(T_.eclat - 0.2, T_.fin, x));
      pivot.scale.set(s, s, s);
      const a = borne(T_.led, T_.led + 0.55, x);
      lumina.allumer(a + Math.sin(x * 3.2) * 0.1 * a);
      const dt = Math.max(0, x - precedent);
      precedent = x;
      const p = geo.attributes.position;
      for (let i = 0; i < n; i++) {
        let y = p.getY(i) + vit[i] * dt;
        if (y > 4.2) y = -4.2;
        p.setY(i, y);
      }
      p.needsUpdate = true;
      rendu.render(scene, cam);
    },
    posTete() {
      lumina.groupe.localToWorld(v.copy(lumina.reperes.tete));
      v.project(cam);
      return { x: v.x * 0.5 + 0.5, y: 0.5 - v.y * 0.5 };
    },
    alleger() { rendu.setPixelRatio(1); cadrer(); poussiere.visible = false; },
    liberer() {
      removeEventListener('resize', cadrer);
      lumina.dispose(); geo.dispose(); texture.dispose(); poussiere.material.dispose();
      rendu.dispose();
    },
  };
}
